import React from 'react';

import BasicModal from '@components/BasicModal';

// Port từ license-cms/source/src/compoments/management/LicenseModal.js.
// Nay dựng trên BasicModal (dùng chung khung Modal với các trang khác).
// Nhãn nút 'Đóng' / 'Lưu' trùng mặc định của BasicModal nên không cần truyền lại.
// Nguồn KHÔNG truyền maskClosable cho antd Modal -> mặc định antd là true,
// nên giữ maskClosable = true (khác mặc định false của BasicModal) để không đổi hành vi.
const LicenseModal = ({
    title,
    visible,
    onOk,
    onCancel,
    loading,
    children,
    objectName,
    width,
    top,
    formId,
    bodyStyle,
    noFooter,
    emptyFooter,
    additionalButton,
    className,
    closable = true,
    centered,
    maskClosable = true,
}) => (
    <BasicModal
        title={title}
        visible={visible}
        onOk={onOk}
        onCancel={onCancel}
        loading={loading}
        objectName={objectName}
        width={width || 800}
        top={top || 40}
        formId={formId}
        bodyStyle={bodyStyle || { padding: '24px', maxHeight: 'calc(78vh - 40px)', overflow: 'auto' }}
        noFooter={noFooter}
        emptyFooter={emptyFooter}
        additionalButton={additionalButton}
        className={className}
        closable={closable}
        centered={centered}
        maskClosable={maskClosable}
    >
        {children}
    </BasicModal>
);

export default LicenseModal;
